/** Stable tropical color style for a tag (same tag = same color everywhere). */
const TAG_STYLES = [
  "bg-[var(--tint-pink)] text-[#E6414F]",
  "bg-[var(--tint-mint)] text-[var(--teal-dark)]",
  "bg-[var(--tint-peach)] text-[#E6414F]",
  "bg-[var(--tint-butter)] text-[var(--sun-dark)]",
];

export const tagStyle = (tag) =>
  TAG_STYLES[[...(tag || "")].reduce((a, c) => a + c.charCodeAt(0), 0) % TAG_STYLES.length];
